export const GEO_TRANSACTION_IDENTIFIER_TYPE = 'Casino';